import { createContext } from '@lit/context';

import { ToastService } from '../services/luds-toast-service';

export const toastServiceContext = createContext<ToastService>(Symbol('toast-service'));
